export default "__VITE_ASSET__DooVmkqQ__"